import type { StackProps } from "@mui/material";
import { type FC, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { MomentSegmentPreview } from "../../segment/components/manager-v2/moment-segment-preview/moment-segment-preview";
import type { PreviewConfig } from "../../segment/components/manager-v2/moment-segment-preview/types";
import type { MomentFormMoment } from "../types/moment-form-moment";

export const SegmentRecipientPreview: FC<{ show_cc_warning?: boolean } & StackProps> = ({
  show_cc_warning = false,
  ...rest
}) => {
  const { control, getValues } = useFormContext<MomentFormMoment>();

  useWatch({
    control,
    name: [
      "channel",
      "target_channel",
      "target_manager",
      "target_connection_type",
      "only_additional_recipients",
      "additional_recipients",
      "segment.segment_json",
    ],
  });

  const [
    channel,
    target_channel,
    target_manager,
    target_connection_type,
    only_additional_recipients,
    additional_recipients,
    segment_json,
  ] = getValues([
    "channel",
    "target_channel",
    "target_manager",
    "target_connection_type",
    "only_additional_recipients",
    "additional_recipients",
    "segment.segment_json",
  ]);

  const preview_config: PreviewConfig = useMemo(() => {
    if (target_channel)
      return {
        type: "channel",
        data: {
          channels: additional_recipients.length,
          segment: segment_json,
          channel_ids: additional_recipients,
        },
      };

    if (only_additional_recipients)
      return {
        type: "only_additional_recipients",
        data: {
          segment: segment_json,
          additional_recipients: additional_recipients.length,
          additional_recipient_ids: additional_recipients,
        },
      };
    if (target_connection_type)
      return { type: "connection", data: { segment: segment_json, target_connection_type } };
    if (target_manager) return { type: "manager", data: { segment: segment_json } };

    return { type: "segment", data: { segment: segment_json } };
  }, [
    only_additional_recipients,
    segment_json,
    additional_recipients,
    target_channel,
    target_connection_type,
    target_manager,
  ]);

  return (
    <MomentSegmentPreview
      channel={channel}
      preview_config={preview_config}
      show_cc_warning={show_cc_warning}
      {...rest}
    />
  );
};
